import { useEffect, useRef, useState } from 'react';

/**
 * dropdown 외부 클릭 시 dropdown 닫기
 */
export const useClickOutside = () => {
  const [isMenuDropdownOpen, setIsMenuDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsMenuDropdownOpen(false);
      }
    };

    if (isMenuDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuDropdownOpen]);

  return { dropdownRef, isMenuDropdownOpen, setIsMenuDropdownOpen };
};
